import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Registration} from "../../../models/registration";

import {Event} from "../../../models/event";
import {EventType} from "../../../models/event-type";
import {RegistrationControllerService} from "../../../services/registration-controller/registration-controller.service";

@Component({
  selector: "card",
  templateUrl: "./card.component.html",
  providers: [RegistrationControllerService],
})

export class CardPageComponent implements OnInit {

  public registration: Registration;
  public serviceId: string;
  public registrationId: string;

  constructor(private registrationController: RegistrationControllerService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  public ngOnInit() {
    this.reloadRegistration();
  }

  public reloadRegistration() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.registrationId = params.registrationId;
      this.registrationController.getRegistration(this.registrationId).subscribe(
        (data) => this.registration = data,
      );
    });
  }

  public refreshRegistration(event: Event) {
    if (event.eventType === EventType.Add || event.eventType === EventType.Update) {
      this.router.navigate(["/services/" + this.serviceId + "/registrations/" + event.id],
        {relativeTo: this.route, skipLocationChange: false});
    } else if (event.eventType === EventType.Delete) {
      this.router.navigate(["/services/" + this.serviceId + "/registrations"]);
    }
  }
}
